import { navigateTo } from "#imports";
export function redirectToWhenUnlogged(to, from) {
  let newRoute = to.meta.redirectToWhenUnlogged;
  Object.keys(from.params).forEach((param) => {
    newRoute = newRoute.replace(`[${param}]`, from.params[param]);
  });
  return navigateTo(newRoute, { external: true });
}
